import { DEMOGRAPHIC_QUERY } from "@/graphql/demographic-query";
import { DemographicData } from "@/models/demographic/demographic.interface";
import gql from "graphql-tag";
import { Component, Prop, Vue } from "vue-property-decorator";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";
import { utils } from "@/utils/utils";

@Component({
  name: "demographic-form",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-input-datepicker": FormInputDatepickerComponent,
  },
})
export default class DemographicDataComponent extends Vue {
  public demographicData: DemographicData[] = [];

  @Prop()
  public demographicKey!: {
    payloadName: string;
    payloadSignatureKey: string;
  };
  @Prop()
  public demographic!: any;
  @Prop()
  public formType!: string;
  @Prop()
  public editForm!: boolean;

  public demographicPayload: any = {
    hispanicorLatino: {
      hispanicorLatino: "",
    },
    ethnicGroupYourself: {
      centralAmerican: "",
      cuban: "",
      dominican: "",
      mexican: "",
      southAmerican: "",
      others: "",
    },
    raceYourself: {
      blackAmerican: "",
      asian: "",
      nativeHawaiian: "",
      pacificIslander: "",
      white: "",
      americanIndian: "",
      dob: "",
    },
  };
  public currentRoute = "";
  public isDisable = false;

  /*
   * Applicants must be 18 or over. The date picker takes the rule directly and
   * greys out anything newer, so an ineligible date of birth cannot be chosen
   * or typed. The check below stays as the backstop, for a value restored from
   * a draft saved before the rule existed.
   */
  public readonly applicantMinAge = 18;

  /*
   * Under 18 by the date of birth given.
   */
  public get isErrDobAge(): boolean {
    const dob = this.demographicPayload?.raceYourself?.dob;
    if (!dob) {
      return false;
    }
    const dobDate = new Date(dob);
    const minAgeDate = new Date();
    minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
    return dobDate > minAgeDate;
  }

  public async created() {
    this.currentRoute = this.$route.path;
    if (this.currentRoute.split("/")[1] === "form") {
      let payloadStorage: any = localStorage.getItem(
        this.demographicKey.payloadName
      );
      payloadStorage = JSON.parse(payloadStorage);
      if (
        this.demographicKey.payloadSignatureKey &&
        payloadStorage &&
        payloadStorage[this.demographicKey.payloadSignatureKey].demographic
      ) {
        this.demographicPayload =
          payloadStorage[this.demographicKey.payloadSignatureKey].demographic;
      }
    } else {
      this.demographicPayload = this.demographic;
    }
    await this.$apollo
      .query({
        query: gql`query ${DEMOGRAPHIC_QUERY}`,
      })
      .then((result) => {
        this.demographicData = result.data.demographicDatas.data;
        this.isDisable = utils.disableField(this.editForm, this.formType);
      });
  }

  public updated() {
    if (
      this.demographicPayload.hispanicorLatino.hispanicorLatino === "No" ||
      this.demographicPayload.hispanicorLatino.hispanicorLatino === "Refused"
    ) {
      Object.keys(this.demographicPayload.ethnicGroupYourself).forEach(
        (key) => {
          this.demographicPayload.ethnicGroupYourself[key] = "";
        }
      );
    }
    this.$emit("input", this.demographicPayload);
  }

  /*
   * The date of birth is rendered with the shared MM-DD-YYYY picker every other
   * date on these forms uses, whatever the CMS says the control is. It was
   * configured as a month input, which cannot express a day and so cannot be
   * checked exactly against the age rule. Deciding it here keeps the two in
   * step without waiting on a content change.
   */
  public fieldComponent(fields: any): string {
    return fields.name === "dob" ? "b-form-input-datepicker" : fields.field;
  }

  public fieldBindings(formInput: any, fields: any): any {
    if (fields.name === "dob") {
      // Drop the CMS propBind: it carries type "month", which would fight the
      // picker being rendered instead.
      return {};
    }
    return fields.options ? formInput.propBind.fieldGroups : fields.propBind;
  }

  public fieldUpdate(groupName: string) {
    if (groupName === "ethnicGroupYourself") {
      if (
        this.demographicPayload.hispanicorLatino.hispanicorLatino === "" ||
        this.demographicPayload.hispanicorLatino.hispanicorLatino === "No" ||
        this.demographicPayload.hispanicorLatino.hispanicorLatino === "Refused"
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
}
